import React, { useCallback, useEffect, useRef, useState } from 'react';

// import styles from './styles';
// import { withStyles } from '@mui/styles';

import styles from "./dashboard.module.css"
import Home from './components/home';
import Alarm from './components/alarm';
import Attendance from './components/attendance';
import Avatar from './components/avatar';
import Book from './components/book';
import Chart from './components/chart';
import Edit from './components/edit';
import Envelope from './components/envelope';
import Sms from './components/sms';
import Notification from './components/notification';
import Question from './components/question';
import Report from './components/report';
import Restaurant from './components/restaurant';
import { RegularMealDeadlines } from '../etc/regularmealdeadline';
import Search from './components/search';
import NotificationWrite from './components/notificationwrite';
import { ReactComponent as LogoSvg } from '../svg/newlogowhite.svg';
import { ReactComponent as ShapeLogoSvg } from '../svg/onlyshape.svg';
import { ReactComponent as MomWhiteLogoSvg } from "../svg/logo/mom/whitelogo.svg";

import menulist from './components/menulist'
import { forEachChild } from 'typescript';

import { Route, HashRouter as Router, Link, Switch } from "react-router-dom";
import { io, Socket } from "socket.io-client";
import QuestionWrite from './components/questionwrite';
import Profile from './components/profile';
import NotificationDetail from './components/controls/notificationdetail';
import TemporaryDrawer from './components/drawer';
import Text from './components/test';
import { Helmet } from 'react-helmet';
// import { ipcRenderer } from 'electron';
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

import nativePushRegistartion from "../service/pushnotification";
import app from "../service/firebaseinit";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import { useHistory } from "react-router-dom";
import { IonAvatar, useIonAlert } from "@ionic/react";
import { getAvatarSrc } from '../etc/functions';
import { getFetch } from '../fetch/fetch';
import Diagnosis from './components/diagnosis';
import PhoneDialer from './components/phonedialer';
import PhoneIcon from '@mui/icons-material/Phone';

import { App, AppState } from "@capacitor/app";
import FacilityMain from './components/controls/newtodo/facilitymain';
import SeatPractice from './components/controls/seatpracitce';
import Heart from './components/heart';
import WifiPermit from './components/controls/wifipermit/wifipermit';
import WifipermitForPc from './components/wifipermitforpc';
import Iot from './components/iot';
import { englishAcademyNameToKorean, renderLogoSvg, returnNeedAuthorizeAcademy } from '../data/locationFuntion';
import Checklist from './components/controls/checklist/checklist';
import Money from './components/controls/money/money';
import Booking from './components/controls/booking/booking';
import NewTodo from './components/controls/newtodo/components/check';
import NewTodoMain from './components/controls/newtodo/main';
import ContentMain from './components/contents/contentsmain';
import MentorChat from './components/mentorchat';
import MentorChatForTeacher from './components/controls/mentorchatforteacher';
import WriteMentorDescription from './components/controls/manageconsult/pages/writementordescription';
import SalaryMain from './components/controls/salary/salarymain';
import ChartsMain from './components/controls/charts/ChartsMain';



interface props {
    // classes: any;
    history: any;
    location: any;
    socket: Socket;
}

interface user {
    name: string;
    value: "student" | "teacher" | "parent" | "staff";
    id: number;
    academy?: string;
    location?: string;
    job?: string;
    todoistApiKey?: string;
    todoistEmail?: string;
    avatar?: number;
    filteredLocation?: string[];
    phoneNumber?: string;
}

type currentSideBarMenuList = "avatar" | "home" | "notification" | "alarm" | "edit" | "book" | "question" | "restaurant" | "envelope" | "sms" | "search" | "chart" | "attendance" | "출석 관리 보고" | "text" | "diagnosis" | "check" | "heart" | "wifipermit" | "wifipermitregister" | "circle-check" | "mentorchat" | "mentorchatforteacher";



const Dashboard: React.FC<props> = (props) => {
    // const classes = props.classes;
    const socket = props.socket;
    const [count, setCount] = useState(0);
    const [smsCount, setSmsCount] = useState(0);
    const [familyCount, setFamilyCount] = useState(0);
    const [mentorCount, setMentorCount] = useState(0);
    const [opinionCount, setOpinionCount] = useState(0);
    const [user, setUser] = useState<user | null>();
    const [location, setLocation] = useState<string>("out");
    const [sideBarMenuList, setSideBarMenuList] = useState<any>();
    const [currentSideBarMenuList, setCurrentSideBarMenuList] = useState<currentSideBarMenuList>("home");

    const [newNotification, setNewNotification] = useState(1);
    const [notificationReadUpdate, setNotificationReadUpdate] = useState(0);

    const [newLocation, setNewLocation] = useState(1);

    const [messageUpdate, setMessageUpdate] = useState(0);
    const [familyMessageUpdate, setFamilyMessageUpdate] = useState({ number: 0, isUpdateNeeded: true });

    const history = useHistory();
    const [presentAlert] = useIonAlert();

    const [avatarSrc, setAvatarSrc] = useState<string | null>();

    const [notificationCount, setNotificationCount] = useState(0);
    const [unReadTodoistNumber, setUnReadTodoistNumber] = useState(0);
    const [facilityUncompletedCount, setFacilityUncompletedCount] = useState(0);
    const [isDionFoodUser, setIsDionFoodUser] = useState(false);
    const [newTodoistDataUpdate, setNewTodoistDataUpdate] = useState(0);
    const [phoneDialerOpen, setPhoneDialerOpen] = useState(false);

    //지점별 정기식 설정 (서버 주도 - 로그인 직후 로드해서 도시락 신청 화면 진입 시 깜빡임 방지)
    const [regularMealSetting, setRegularMealSetting] = useState<{ price: number, isMenuVisible: boolean, deadlines: RegularMealDeadlines | null }>({ price: 8000, isMenuVisible: false, deadlines: null });

    useEffect(() => {

        getFetch("/dashboard/restaurant/regularmeal/mysetting").then((result: any) => {
            if (result.message === "success") {
                setRegularMealSetting({ price: result.price, isMenuVisible: result.isMenuVisible, deadlines: result.deadlines ? result.deadlines : null });
            }
        }).catch(() => { });

    }, []);

    const requestTimestampsRef = useRef<number[]>([]);
    const lastCallTimeRef = useRef<number>(0);

    //소켓 이벤트 폭주 시 setMessageUpdate를 2초에 최대 1회로 병합하기 위한 ref
    const messageUpdateTimerRef = useRef<any>(null);
    const lastMessageUpdateTimeRef = useRef<number>(0);

    const [mentorMessageUpdate, setMentorMessageUpdate] = useState({ number : 0, isUpdateNeeded: true });

    const handleStateChange = (state: AppState) => {


        if (state.isActive) {
            unreadMessage();
            getNotificationNumber();
        }
    }

    //스마트폰 백그라운드에서 포어그라운드로 올 때 한번 더 공지사항 새로운거 채팅 새로운거 확인해주기
    useEffect(() => {

        App.addListener("appStateChange", handleStateChange);

        return () => {
            App.removeAllListeners();
        }

    }, []);



    useEffect(() => {

    })

    //notification count check 하는 기능-----------------------------------------
    const getNotificationNumber = async () => {

        // if (props.location === "notification") {
        //     return;
        // }
        try {
            const result: any = await getFetch("/dashboard/notification/getNumber");


            if (result.message === "success") {
                setNotificationCount(result.count);
            }


        } catch (e) {

            return;
        }
    }

    //해결 안된 건의사항 count check 하는 기능-----------------------------------------
    const getOpinionNumber = async () => {

        // if (props.location === "notification") {
        //     return;
        // }
        try {
            const result: any = await getFetch("/dashboard/search/count");


            if (result.message === "success") {
                setOpinionCount(result.count);
            }
        }
        catch (e) {

            return;
        }
    }

    useEffect(() => {
        getOpinionNumber();
    }, []);

    const handleReadNotification = () => {

        const randomNumber = Math.random();
        setNotificationReadUpdate(randomNumber);

    }

    useEffect(() => {
        getNotificationNumber();
    }, [newNotification, notificationReadUpdate]);
    //---------------------------------------------------------------------------




    //답장 안한 message 갯수 물어보는 기능
    const unreadMessage2 = async () => {
        var token: any = "";
        //-----// 만약 electron 이라면 저장되어 있는 토큰 가져오는 기능----------
        if (window.electron) {
            token = await window.electron.sendMessageApi.getToken();
        }
        //------------------------------------------------------------------

        //네이티브 라면 토큰 가져오는 기능
        if (Capacitor.isNativePlatform()) {
            const { value } = await Preferences.get({ key: "token" });

            token = value;
        }

        fetch("https://peetsunbae.com/dashboard/envelope/number", {
            method: "GET",
            credentials: "include",
            headers: { 'Authorization': token }
        }).then((response) => {
            response.json()
                .then((result) => {


                    setCount(result.data);
                    const familyUnreadNumber = result.familyUnreadNumber;
                    setFamilyCount(familyUnreadNumber);
                    const mentorCount = result.mentorCount;
                    setMentorCount(mentorCount);

                })
        }).catch(error => {

        })
    }

    const unreadMessage = useCallback(() => {

        const now = Date.now();

        requestTimestampsRef.current = requestTimestampsRef.current.filter((timestamp) => now - timestamp < 3000);

        requestTimestampsRef.current.push(now);

        if(requestTimestampsRef.current.length < 5){
            unreadMessage2();
            lastCallTimeRef.current = now;
        }else{
            if(now - lastCallTimeRef.current > 2000){
                unreadMessage2();
                lastCallTimeRef.current = now;
            }
        }

    }, [unreadMessage2]);

    //setMessageUpdate(Math.random())는 하위 컴포넌트들의 목록 재조회(getChatRooms 등)를 일제히 발화시키므로
    //소켓 이벤트 폭주(단체발송 후 읽음 이벤트 등) 시 2초에 최대 1회로 병합한다.
    //한동안 이벤트가 없었으면 즉시 반영(leading)해서 평상시 실시간성은 유지.
    const scheduleMessageUpdate = useCallback(() => {

        const now = Date.now();

        if (now - lastMessageUpdateTimeRef.current > 2000) {
            lastMessageUpdateTimeRef.current = now;
            setMessageUpdate(Math.random());
            return;
        }

        if (messageUpdateTimerRef.current) {
            return;
        }

        messageUpdateTimerRef.current = setTimeout(() => {
            messageUpdateTimerRef.current = null;
            lastMessageUpdateTimeRef.current = Date.now();
            setMessageUpdate(Math.random());
        }, 2000);

    }, []);

    //SMS 문자 채팅방 안읽음 갯수(좌측 메뉴 배지)
    const getSmsNumber = useCallback(async () => {
        if (!user || (user.value !== "staff" && user.value !== "teacher") || !user.todoistApiKey) {
            return;
        }
        try {
            const result: any = await getFetch("/dashboard/sms/number");
            if (result.message === "success") {
                setSmsCount(result.data);
            }
        } catch (e) {
            //폴링 실패 시 기존 값 유지
        }
    }, [user]);

    //수신은 윈도우 워커가 appdb에 직접 기록 → 소켓 알림 불가. 주기적 폴링으로 배지 갱신.
    useEffect(() => {
        if (!user || (user.value !== "staff" && user.value !== "teacher") || !user.todoistApiKey) {
            return;
        }
        getSmsNumber();
        const smsTimer = setInterval(getSmsNumber, 10000);
        return () => clearInterval(smsTimer);
    }, [user, getSmsNumber]);

    //처음 dashboard 진입 시 토큰 가지고 있는지랑 가지고 있다면 토큰 정보 받기-------
    useEffect(() => {

        unreadMessage();

        async function start() {
            var token: any = "";
            //-----// 만약 electron 이라면 저장되어 있는 토큰 가져오는 기능----------
            if (window.electron) {
                token = await window.electron.sendMessageApi.getToken();
            }
            //------------------------------------------------------------------

            //네이티브 라면 토큰 가져오는 기능
            if (Capacitor.isNativePlatform()) {
                const { value } = await Preferences.get({ key: "token" });

                token = value;
            }



            fetch("https://peetsunbae.com/dashboard/home/start", {
                method: "GET",
                credentials: "include",
                headers: { 'Authorization': token }
            }).then((response) => {
                response.json()
                    .then((result) => {

                        if (result.message === "LOGIN") {

                            var academy = result.academy ? result.academy : "";

                            if(academy === "sunbaesha"){
                                academy = "sunbae";
                            }


                            setUser({
                                name: result.name,
                                value: result.value,
                                id: result.id,
                                academy,
                                location: result.location,
                                job: result.job,
                                todoistApiKey: result.todoistApiKey,
                                todoistEmail: result.todoistEmail,
                                avatar: result.avatar,
                                filteredLocation: result.filteredLocation,
                                phoneNumber: result.phoneNumber
                            });

                            //result.email에 dionfood가 들어가있으면 dionfood 유저로 판단
                            if (result.email.includes("dionfood") || result.email.includes("01073118524") || result.email.includes("01063740987") ) {
                                setIsDionFoodUser(true);
                                // /dashboard/restaurant으로 이동
                                history.push("/dashboard/restaurant");
                            }
                        }
                        if (result.message === "NOT_LOGIN") {
                            props.history.push("/");
                        }

                    })
            }).catch(error => {

            })
        }

        start();
    }, []);
    //-----------------------------------------------------------------------

    //push 등록---------------------------------------------------------------

    //push 등록----------------------------------------------------------------------------

    useEffect(() => {
        //web인 상태에서 푸시 메세지
        if (!Capacitor.isNativePlatform()) {


            if (!navigator) {

                return;
            }

            if (!navigator.serviceWorker) {

                return;
            }



            const messaging = getMessaging(app);

            getToken(messaging, { vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY }).then(async (currentToken) => {
                if (currentToken) {



                    var userIdToken: any = "";

                    if (Capacitor.isNativePlatform()) {
                        const { value } = await Preferences.get({ key: "token" });

                        userIdToken = value;
                    }

                    fetch("https://peetsunbae.com/push/registration", {
                        method: "post",
                        headers: {
                            "content-type": "application/json",
                            "Authorization": userIdToken
                        },
                        credentials: "include",
                        body: JSON.stringify({
                            token: currentToken
                        })
                    }).then((response: any) => {
                        response.json()
                            .then((result: any) => {

                            })
                    })

                    //   onMessage(messaging, (payload) => {
                    //     
                    //     
                    //   })

                } else {

                }
            }).catch((err) => {

            })

        }
    }, [navigator.serviceWorker]);

    useEffect(() => {
        nativePushRegistartion(history, presentAlert);
    }, [])

    //-------------------------------------------------------------------------------


    //-----------------------------------------------------------------------

    //로그아웃 시키는 기능-----------------------------------------------------
    const logOut = async () => {
        //일렉트론 이라면 저장된 토큰 삭제-----------------------------------------------------
        if (window.electron) {
            const result = await window.electron.sendMessageApi.setToken("logOut");

        }

        if (Capacitor.isNativePlatform()) {
            await Preferences.set({
                key: "token",
                value: "logOut"
            })
        }

        // ipcRenderer.send("signOut");

        //-----------------------------------------------------------------------

        //쿠키 삭제 위해 서버로 fetch 보냄-----------------------------------------
        fetch("https://peetsunbae.com/login/logout", {
            method: "GET",
            credentials: "include"
        }).then((response) => {
            response.json()
                .then((result) => {

                    props.history.push({
                        pathname: "/",
                        state: { from: "dashboard" }
                    });
                })
        }).catch((err) => {

        })
        //--------------------------------------------------------------------------

        //-------------------------------------------------------------------
    }
    //-----------------------------------------------------------------------

    //dashboard 처음 진입 시 외출 중인지 내원 중인지 가져오는 기능-------------------------------
    useEffect(() => {


        async function start() {
            var token: any = "";
            //-----// 만약 electron 이라면 저장되어 있는 토큰 가져오는 기능----------
            if (window.electron) {
                token = await window.electron.sendMessageApi.getToken();
            }
            //------------------------------------------------------------------

            //네이티브 라면 토큰 가져오는 기능
            if (Capacitor.isNativePlatform()) {
                const { value } = await Preferences.get({ key: "token" });

                token = value;
            }

            fetch("https://peetsunbae.com/dashboard/where", {
                method: "GET",
                credentials: "include",
                headers: { 'Authorization': token }
            }).then((response) => {
                response.json()
                    .then((result) => {

                        if (result.message === "success") {



                            if (result.location === "out") {
                                setLocation("out");
                            }
                            if (result.location === "in") {
                                setLocation("in");
                            }

                        } else {

                        }

                    })
            }).catch(error => {

            })
        }

        start();
    }, []);
    //-----------------------------------------------------------------------------------------


    //소켓이 자기 방 알려주는 곳-----------------------------------------------------------------
    useEffect(() => {
        if (user && socket) {
            socket.emit("myRoom", user.id);

            if (user.value === "teacher" || user.value === "staff") {

                socket.emit("teacherRoom");
            }

        }

    }, [user, socket]);


    //서버 껏다 켰을때 소켓이 방 다시 알려주는 기능-----------------------------
    useEffect(() => {
        if (!user) {
            return;
        }

        const sendMyRoom = () => {
            if (user) {
                socket.emit("myRoom", user.id);

                if (user.value === "teacher" || user.value === "staff") {

                    socket.emit("teacherRoom");
                }
            }
        }

        socket.on("connect", () => {
            sendMyRoom();
        });

        return function cleanup() { socket.off("connect"); }

    }, [user]);

    //---------------------------------------------------------------------

    //---------------------------------------------------------------------------------------------

    //socket이 실시간 업데이트 시행하는 곳----------------------------------------------------------
    useEffect(() => {


        //-----//새로운 공지사항 왔을때 공지사항 업데이트 하는 기능---------------------------
        socket.on("newNotification", () => {
            const randomNumber = Math.floor(Math.random() * (99999 - 10000) + 10000);
            setNewNotification(randomNumber);
        })
        //-----//--------------------------------------------------------------------------

        //-----//유저 위치 변경 됬을 때 업데이트 하는 기능-------------------------------

        socket.on("newLocation", (direction: string) => {

            if (direction === "inside") {
                setLocation("out");
            }
            if (direction === "outside") {
                setLocation("in");
            }
        });
        //-----//---------------------------------------------------------------------

        //-----------------------------------------------------------------------------

        //새로운 답변 달렸을 때 알림 받는 기능--------------------------------------------
        socket.on("newAnswer", (answerUserName) => {


            new window.Notification("답변이 달렸습니다.", { body: `${answerUserName}님이 답변을 다셨습니다.` });
        })

        //--------------------------------------------------------------------------------

        //새로운 메세지 받았을 때
        socket.on("newMessage", (messageUserName) => {
            unreadMessage();
            new window.Notification("새로운 메세지가 왔습니다.", { body: `${messageUserName}님이 메세지를 보냈습니다.` });
        })

        return function cleanup() {
            socket.off("newAnswer");
            socket.off("newMessage");
            socket.off("newLocation");
            socket.off("newNotification");
        }

    }, []);
    //--------------------------------------------------------------------------------------------

    //새로운 메세지 왔을 때 알림 받는 기능------------------------------------------------

    useEffect(() => {

        socket.on("newChatMessage", () => {


            // new window.Notification("새로운 메세지가 왔습니다.", {body : `메세지를 확인해주세요.`});

            unreadMessage();
            scheduleMessageUpdate();
        })

        return function cleanup() { socket.off("newChatMessage"); }

    }, []);


    useEffect(() => {

        if (!user) {
            return;
        }

        if (user.value === "teacher" || user.value === "staff") {

            socket.on("studentReadMessage", (chatRoomId : any, academy : any) => {


                // new window.Notification("새로운 메세지가 왔습니다.", {body : `메세지를 확인해주세요.`});

                //신버전 서버는 (chatRoomId, academy)를 실어줌 → 다른 학원 이벤트는 무시
                //구버전 서버는 인자가 없으므로 기존 동작 그대로
                if (academy && user.academy) {
                    const eventAcademy = academy === "sunbaesha" ? "sunbae" : academy;
                    const myAcademy = user.academy === "sunbaesha" ? "sunbae" : user.academy;
                    if (eventAcademy !== myAcademy) {
                        return;
                    }
                }

                unreadMessage();
                scheduleMessageUpdate();
            })

            return function cleanup() {
                //주의: 여기서 socket.off("newChatMessage")를 하면 위의 deps [] effect가 등록한
                //newChatMessage 리스너까지 영구히 꺼지는 버그가 있었음 (인자 없는 off는 이벤트 전체 제거)
                socket.off("studentReadMessage");
            }

        }

    }, [user]);

    useEffect(() => {

        if (!socket) {
            return;
        }

        socket.on("newFamilyMessage", () => {



            unreadMessage();
            scheduleMessageUpdate();

            const newFamilyMessageUpdate = {
                number: Math.random(),
                isUpdateNeeded: true
            }

            setFamilyMessageUpdate({ ...newFamilyMessageUpdate });

        })

        socket.on("familyReadMessage", () => {



            unreadMessage();
            scheduleMessageUpdate();

            const newFamilyMessageUpdate = {
                number: Math.random(),
                isUpdateNeeded: false
            }

            setFamilyMessageUpdate({ ...newFamilyMessageUpdate });

        })

        return function cleanup() { socket.off("familyReadMessage"); socket.off("newFamilyMessage"); }

    }, [socket]);

    useEffect(() => {

        if (!socket) {
            return;
        }

        socket.on("newCoachMessage", () => {

            console.log("새로운 멘토 메세지 받음");

            unreadMessage();
            scheduleMessageUpdate();

            const newMentorMessageUpdate = {
                number: Math.random(),
                isUpdateNeeded: true
            }

            setMentorMessageUpdate({ ...newMentorMessageUpdate });

        })

        socket.on("coachReadMessage", () => {

            console.log("멘토 메세지 읽음");

            unreadMessage();
            scheduleMessageUpdate();

            const newCoachMessageUpdate = {
                number: Math.random(),
                isUpdateNeeded: false
            }

            setMentorMessageUpdate({ ...newCoachMessageUpdate });

        })

        return function cleanup() { socket.off("newCoachMessage"); socket.off("coachReadMessage"); }

    }, [socket]);

    useEffect(() => {

        if (!socket) {
            return;
        }

        socket.on("newOpinion", () => {
            getOpinionNumber();
        })

        return function cleanup() { socket.off("newOpinion"); }

    }, [socket]);

    useEffect(() => {

        if (!socket) {
            return;
        }

        if (!user) {
            return;
        }

        //newTodoistData event 받았을 때
        socket.on("newTodoistData", () => {
            setNewTodoistDataUpdate(Math.random());
        })

        return function cleanup() { socket.off("newTodoistData"); }

    }, [user, socket]);

    useEffect(() => {

        getUnreadTodoistNumber();
        getFacilityUncompletedCount();

    }, [newTodoistDataUpdate, user]);

    const getUnreadTodoistNumber = async () => {

        try {

            if (!user) {
                return;
            }

            //todoistApiKey 없는 계정은 본사직원/시설 라우터 접근 불가 → 폴링 생략
            if (!user.todoistApiKey) {
                return;
            }

            const result: any = await getFetch("/dashboard/todoist/unreadCount");

            console.log(result);

            setUnReadTodoistNumber(result.count);

        } catch (e) {
            console.log(e);
        }

    }

    //시설 관리 메뉴 미완료 갯수 배지
    const getFacilityUncompletedCount = async () => {

        try {

            if (!user) {
                return;
            }

            if (user.value !== "staff" && user.value !== "teacher") {
                return;
            }

            //todoistApiKey 없는 계정은 본사직원/시설 라우터 접근 불가 → 폴링 생략
            if (!user.todoistApiKey) {
                return;
            }

            const result: any = await getFetch("/dashboard/todoist/facilityUncompletedCount");

            if (result.message === "success") {
                setFacilityUncompletedCount(result.count);
            }

        } catch (e) {
            console.log(e);
        }

    }


    //활성화된 메뉴에 따라 메뉴 하이라이트 되는 기능-------------------------------------------------
    const activateMenuList = (current: currentSideBarMenuList) => {
        setCurrentSideBarMenuList(current);
    }
    //----------------------------------------------------------------------------------------


    //아바타 그림 소스 가져오기
    useEffect(() => {

        const getAvatar = async () => {
            const avatarSrc: any = await getAvatarSrc();


            setAvatarSrc(avatarSrc);
        }

        getAvatar();

    }, []);
    //--------------------------------


    return (

        <main className={styles.main}>

            <Helmet>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1, user-scalable=yes"
                />
            </Helmet>


            <div className={`${styles.appBar} ${styles.notablet}`}>
                <div className={styles.logoDiv}>

                    {/* <LogoSvg className={styles.logoSvg} /> */}
                    {
                        (user && user.academy) &&
                        renderLogoSvg(user.academy, "white", (user && user.academy !== "alltarget") ? styles.logoSvg : styles.bigLogoSvg)
                    }
                </div>
                <div className={styles.profileDiv}>
                    {/* <Link to="/dashboard/profile">
                            <div className={styles.profileConfig}>
                                프로필설정
                            </div>
                        </Link> */}
                    {user?.value === 'teacher' &&
                    <div className={styles.phoneButton} onClick={() => setPhoneDialerOpen(prev => !prev)}>
                        <PhoneIcon sx={{ fontSize: 20, color: 'white' }} />
                    </div>
                    }
                    <div className={styles.avatarCircle} onClick={logOut}>
                        <img className={styles.avatar} src="img/avatarG.svg" alt="avatar"></img>
                    </div>
                    <div className={styles.logout} onClick={logOut}>
                        로그아웃
                    </div>
                </div>
            </div>

            <div className={styles.body}>
                <div className={`${styles.sideMenu} ${styles.notablet}`}>
                    <div className={styles.sideMenuProfile}>
                        <div className={styles.where}>
                            {
                                location === "in" &&
                                <>
                                    <img className={styles.inside} src="img/inside.svg" alt="outside"></img>
                                    <div className={styles.outsideText}>공부중</div>
                                </>
                            }
                            {
                                location === "out" &&
                                <>
                                    <img className={styles.outside} src="img/outside.svg" alt="outside"></img>
                                    <div className={styles.outsideText}>외출중</div>
                                </>
                            }

                        </div>
                        {
                            (!avatarSrc && user && user.academy) &&
                            <div className={styles.sideMenuAvatar}>
                                {/* <ShapeLogoSvg className={styles.logo2} /> */}
                                {
                                    renderLogoSvg(user.academy, "shape", (user && user.academy !== "alltarget") ? styles.logo2 : styles.bigLogo2)
                                }
                            </div>
                        }
                        {
                            avatarSrc &&
                            <IonAvatar className={styles.ionAvatar}>
                                <img src={avatarSrc} className={styles.ionAvatarImg} />
                            </IonAvatar>
                        }

                        <div className={styles.sideMenuName}>
                            {(user && user.academy) && englishAcademyNameToKorean(user.academy)}<span> </span>
                            {user && user.name}
                        </div>
                    </div>
                    <div className={styles.sideMenuListDiv}>
                        <ul className={styles.sideMenuList}>
                            {user &&
                                menulist.map((each) => {


                                    if (isDionFoodUser) {
                                        //home이랑 restaurant만 보여주기
                                        if (each.name !== "restaurant") {
                                            return;
                                        }
                                    }

                                    if (each.value.includes(user.value) && user.academy && each.academy.includes(user.academy)) {

                                        const needAuthorizeNeedAcademyList = returnNeedAuthorizeAcademy();

                                        if (each.job && needAuthorizeNeedAcademyList.includes(user.academy)) {
                                            const preUserJob = user.job;
                                            //userJob에 뒤에 붙어있는 숫자 제거

                                            if (!preUserJob) {
                                                return;
                                            }

                                            const userJob = preUserJob.replace(/[0-9]/g, "");

                                            var isIncluded = false;

                                            each.job.includes(userJob) ? isIncluded = true : isIncluded = false;

                                            if (!isIncluded) {
                                                return;
                                            }
                                        }

                                        if(user.job === "mentor" && each.notForMentor){
                                            return;
                                        }

                                        // todoistApiKey 가드
                                        if ((each as any).requireTodoistKey && !user.todoistApiKey) {
                                            return null;
                                        }

                                        if (each.name !== currentSideBarMenuList) {
                                            return (

                                                <Link key={each.name} to={"/dashboard/" + each.name}>
                                                    <li className={styles.sideMenuListSection}>
                                                        <div className={styles.menuimgcontainer}>
                                                            <img src={"img/off/" + each.name + ".svg"} alt={each.name} className={`${styles.sideMenuListImg} ${each.name === "diagnosis" ? styles.diagnosisPicture : ""}`}></img>
                                                        </div>
                                                        <div className={styles.sideMenuListText}>
                                                            {each.description}
                                                        </div>
                                                        <div className={`${styles.sideMenuListText} ${styles.mobile}`}>

                                                            {
                                                                each.description === "지각/결석 사유 제출" ? "사유 제출" : ""
                                                            }
                                                            {
                                                                each.description === "나에게 온 메시지" ? "메시지" : ""
                                                            }
                                                            {
                                                                each.description === "상담일지 적기" ? "일지 적기" : ""
                                                            }
                                                            {
                                                                (each.description != "지각/결석 사유 제출" && each.description != "나에게 온 메시지" && each.description != "상담일지 적기") ? each.description : ""
                                                            }
                                                        </div>
                                                        {
                                                            (each.name === "envelope" && count > 0) ?
                                                                <div className={styles.noticeNumber}>{count} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "sms" && smsCount > 0) ?
                                                                <div className={styles.noticeNumber}>{smsCount} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "heart" && familyCount > 0) ?
                                                                <div className={styles.noticeNumber}>{familyCount} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "notification" && notificationCount > 0) ?
                                                                <div className={styles.noticeNumber}>{notificationCount} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "circle-check" && unReadTodoistNumber > 0) ?
                                                                <div className={styles.noticeNumber}>{unReadTodoistNumber} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "check" && facilityUncompletedCount > 0) ?
                                                                <div className={styles.noticeNumber}>{facilityUncompletedCount} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "mentorchat") && mentorCount > 0 ?
                                                                <div className={styles.noticeNumber}>{mentorCount} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "search" && opinionCount > 0 && user && (user.value === "teacher" || user.value === "staff")) ?
                                                                <div className={styles.noticeNumber}>{opinionCount} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "mentorchatforteacher" && mentorCount > 0) ?
                                                                <div className={styles.noticeNumber}>{mentorCount} +</div> : ""
                                                        }
                                                    </li>
                                                </Link>
                                            )
                                        } else {
                                            return (
                                                <Link key={each.name} to={"/dashboard/" + each.name}>
                                                    <li className={styles.sideMenuListSection}>
                                                        <div className={styles.menuimgcontainer}>
                                                            <img src={"img/on/" + each.name + ".svg"} alt={each.name} className={`${styles.sideMenuListImg} ${each.name === "diagnosis" ? styles.diagnosisPicture : ""}`}></img>
                                                        </div>
                                                        <div className={styles.sideMenuListTextActive}>
                                                            {each.description}
                                                        </div>
                                                        <div className={`${styles.sideMenuListTextActive} ${styles.mobile}`}>

                                                            {
                                                                each.description === "지각/결석 사유 제출" ? "사유 제출" : ""
                                                            }
                                                            {
                                                                each.description === "나에게 온 메시지" ? "메시지" : ""
                                                            }
                                                            {
                                                                each.description === "상담일지 적기" ? "일지 적기" : ""
                                                            }
                                                            {
                                                                (each.description != "지각/결석 사유 제출" && each.description != "나에게 온 메시지" && each.description != "상담일지 적기") ? each.description : ""
                                                            }
                                                        </div>
                                                        {
                                                            (each.name === "envelope" && count > 0) ?
                                                                <div className={styles.noticeNumber}>{count} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "sms" && smsCount > 0) ?
                                                                <div className={styles.noticeNumber}>{smsCount} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "heart" && familyCount > 0) ?
                                                                <div className={styles.noticeNumber}>{familyCount} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "notification" && notificationCount > 0) ?
                                                                <div className={styles.noticeNumber}>{notificationCount} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "circle-check" && unReadTodoistNumber > 0) ?
                                                                <div className={styles.noticeNumber}>{unReadTodoistNumber} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "check" && facilityUncompletedCount > 0) ?
                                                                <div className={styles.noticeNumber}>{facilityUncompletedCount} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "mentorchat") && mentorCount > 0 ?
                                                                <div className={styles.noticeNumber}>{mentorCount} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "search" && opinionCount > 0 && user && (user.value === "teacher" || user.value === "staff")) ?
                                                                <div className={styles.noticeNumber}>{opinionCount} +</div> : ""
                                                        }
                                                        {
                                                            (each.name === "mentorchatforteacher" && mentorCount > 0) ?
                                                            <div className={styles.noticeNumber}>{mentorCount} +</div> : ""
                                                        }

                                                    </li>
                                                </Link>
                                            )
                                        }
                                    }
                                })
                            }
                        </ul>
                    </div>
                </div>
                <Switch>
                    <>
                        <Route exact path="/dashboard/" render={(props) => <Home activateMenuList={activateMenuList} user={user} socket={socket} newNotification={newNotification} {...props} />} />
                        <Route path="/dashboard/home" render={(props) => <Home activateMenuList={activateMenuList} user={user} socket={socket} newNotification={newNotification} {...props} />} />
                        <Route path="/dashboard/alarm" render={(props) => <Alarm activateMenuList={activateMenuList} user={user} {...props} />} />
                        <Route path="/dashboard/text" render={(props) => <Text activateMenuList={activateMenuList} user={user} {...props} />} />
                        <Route path="/dashboard/attendance" render={(props) => <Attendance socket={socket} user={user} activateMenuList={activateMenuList} messageUpdate={messageUpdate} unreadMessage={unreadMessage} {...props} />} />
                        <Route path="/dashboard/avatar" render={(props) => <Avatar activateMenuList={activateMenuList} socket={socket} user={user} {...props} />} />
                        <Route path="/dashboard/book" render={(props) => <Book activateMenuList={activateMenuList} user={user} {...props} />} />
                        <Route path="/dashboard/chart" render={(props) => <Chart activateMenuList={activateMenuList} user={user} socket={socket} {...props} />} />
                        <Route path="/dashboard/edit" render={(props) => <Edit user={user} activateMenuList={activateMenuList} {...props} />} />
                        <Route path="/dashboard/envelope" render={(props) => <Envelope messageUpdate={messageUpdate} unreadMessage={unreadMessage} socket={socket} user={user} activateMenuList={activateMenuList} {...props} />} />
                        <Route path="/dashboard/sms" render={(props) => <Sms user={user} socket={socket} activateMenuList={activateMenuList} unreadSms={getSmsNumber} {...props} />} />
                        <Route exact path="/dashboard/notification" render={(props) => <Notification user={user} activateMenuList={activateMenuList} {...props} />} />
                        <Route exact path="/dashboard/question" render={(props) => <Question user={user} activateMenuList={activateMenuList} {...props} socket={socket} />} />
                        <Route path="/dashboard/report" render={(props) => <Report activateMenuList={activateMenuList} socket={socket} {...props} />} />
                        <Route path="/dashboard/restaurant" render={(props) => <Restaurant isDionFoodUser={isDionFoodUser} user={user} activateMenuList={activateMenuList} socket={socket} regularMealSetting={regularMealSetting} {...props} />} />
                        <Route path="/dashboard/search" render={(props) => <Search activateMenuList={activateMenuList} user={user} socket={socket} {...props} />} />
                        <Route path="/dashboard/notification/write" render={(props) => <NotificationWrite activateMenuList={activateMenuList} socket={socket} user={user} {...props} />} />
                        <Route path="/dashboard/question/write" render={(props) => <QuestionWrite activateMenuList={activateMenuList} socket={socket} {...props} />} />
                        <Route path="/dashboard/profile" render={(props) => <Profile {...props} />} />
                        <Route path="/dashboard/notificationdetail" render={(props) => <NotificationDetail user={user} handleReadNotification={handleReadNotification} {...props} />} />
                        <Route path="/dashboard/heart" render={(props) => <Heart user={user} socket={socket} activateMenuList={activateMenuList} unreadMessage={unreadMessage} familyMessageUpdate={familyMessageUpdate} {...props} />} />
                        <Route path="/dashboard/diagnosis" render={(props) => <Diagnosis user={user} activateMenuList={activateMenuList} />} />
                        <Route path="/dashboard/check" render={(props) => <FacilityMain user={user} activateMenuList={activateMenuList} socket={socket} newTodoistDataUpdate={newTodoistDataUpdate} {...props} />} />
                        <Route path="/dashboard/seatpractice" render={(props) => <SeatPractice {...props} />} />
                        <Route path="/dashboard/wifipermit" render={(props) => <WifiPermit user={user} activateMenuList={activateMenuList} {...props} />} />
                        <Route path="/dashboard/wifipermitregister" render={(props) => <WifipermitForPc user={user} activateMenuList={activateMenuList} {...props} />} />
                        <Route path="/dashboard/iot" render={(props) => <Iot user={user} activateMenuList={activateMenuList} {...props} />} />
                        <Route path="/dashboard/checklist" render={(props) => <Checklist user={user} activateMenuList={activateMenuList} {...props} />} />
                        <Route path="/dashboard/money" render={(props) => <Money user={user} activateMenuList={activateMenuList} {...props} />} />
                        <Route path="/dashboard/booking" render={(props) => <Booking user={user} activateMenuList={activateMenuList} socket={socket} {...props} />} />
                        <Route path="/dashboard/circle-check" render={(props) => <NewTodoMain user={user} activateMenuList={activateMenuList} socket={socket} newTodoistDataUpdate={newTodoistDataUpdate} {...props} />} />
                        <Route path="/dashboard/contents" render={(props) => <ContentMain user={user} activateMenuList={activateMenuList} socket={socket} {...props} />} />
                        <Route path="/dashboard/mentorchat" render={(props) => <MentorChat user={user} activateMenuList={activateMenuList} socket={socket} mentorMessageUpdate={mentorMessageUpdate} unreadMessage={unreadMessage} {...props} />} />
                        <Route path="/dashboard/mentorchatforteacher" render={(props) => <MentorChatForTeacher user={user} activateMenuList={activateMenuList} socket={socket} mentorMessageUpdate={mentorMessageUpdate} unreadMessage={unreadMessage} {...props} />} />

                        <Route path="/dashboard/writementordescription" render={(props) => <WriteMentorDescription user={user} topPadding={true} />} />
                        <Route path="/dashboard/salary" render={(props) => <SalaryMain user={user} activateMenuList={activateMenuList} {...props} />} />
                        <Route path="/dashboard/datachart" render={(props) => <ChartsMain user={user} activateMenuList={activateMenuList} {...props} />} />
                    </>
                </Switch>
            </div>

            <PhoneDialer open={phoneDialerOpen} onClose={() => setPhoneDialerOpen(false)} user={user} />

        </main>


    )
}

export default Dashboard;
